module.exports = __webpack_public_path__ + "static/media/flexible-lg--cat-2.829c64fd.jpg";